import { render, staticRenderFns } from "./LabelHeader.vue?vue&type=template&id=b00b9e32&scoped=true&"
import script from "./LabelHeader.vue?vue&type=script&lang=js&"
export * from "./LabelHeader.vue?vue&type=script&lang=js&"
import style0 from "./LabelHeader.vue?vue&type=style&index=0&id=b00b9e32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00b9e32",
  null
  
)

export default component.exports